<template>
  <div v-if="account">
    <v-card class="mb-3" elevation="0">
      <v-card-title>Detail du compte "{{account.name}}"</v-card-title>
    </v-card>
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-card>
            <v-card-title>Commandes</v-card-title>
            <v-card-text>
              <v-data-table :items="orders" :headers="orderHeaders">
                <template v-slot:item="{item}">
                  <tr>
                    <td>{{ (item.orderDate)? item.orderDate :item.created_at}}</td>
                    <td>{{item.user.lastname}} {{item.user.firstname}}</td>
                    <td>{{item.service.name}}</td>
                    <td>
                      <v-chip :color="getColor(item.status)" dark>{{item.status}}</v-chip>
                    </td>
                    <td class="text-right">{{$format.money(item.amount)}}</td>
                    <td class="text-right">
                      <v-menu bottom left>
                        <template v-slot:activator="{ on }">
                          <v-btn icon v-on="on">
                            <v-icon>mdi-dots-horizontal</v-icon>
                          </v-btn>
                        </template>
                        <v-list>
                          <v-list-item @click="viewOrder(item)">
                            <v-list-item-title>Voir</v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-card>
            <v-card-title>Transactions</v-card-title>
            <v-card-text>
              <v-data-table
                :headers="transactionHeaders"
                :items="account.funds"
                :sort-by="'created_at'"
                :sort-desc="true"
              >
                <template v-slot:item="{item}">
                  <tr>
                    <td>{{item.created_at}}</td>
                    <td>{{item.description}}</td>
                    <td class="text-right">{{$format.money(item.amount)}}</td>
                    <td class="text-right">{{$format.money(item.balance)}}</td>
                    <td class="text-right">
                      <!--v-menu bottom left>
                        <template v-slot:activator="{ on }">
                          <v-btn icon v-on="on">
                            <v-icon>mdi-dots-horizontal</v-icon>
                          </v-btn>
                        </template>
                        <v-list>
                          <v-list-item @click="view(item)">
                            <v-list-item-title>Voir</v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu-->
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <group-detail :groupId="account.groups[0].id" />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import GroupDetail from "../../components/group/GroupDetail";
import { mapGetters, mapActions } from "vuex";
export default {
  components: {
    GroupDetail
  },
  data: function() {
    return {
      accountId: null,
      orders: [],
      transactionHeaders: [
        { text: "Date", value: "created_at" },
        { text: "Description", value: "description" },
        { text: "Montant", value: "amount", align: "right" },
        { text: "Balance", value: "balance", align: "right" }
      ],
      orderHeaders: [
        { text: "Date", value: "orderDate" },
        { text: "Utilisateur", value: "user_id" },
        { text: "Service", value: "service.name" },
        { text: "Status", value: "status" },
        { text: "Montant", value: "amount", align: "right" },
        { text: "", value: "action" }
      ],
      userHeaders: [
        { text: "Nom", value: "created_at" },
        { text: "Email", value: "description" },
        { text: "Role", value: "amount" },
        { text: "Group", value: "group.name" }
      ]
    };
  },
  mounted: function() {
    this.initialize();
  },
  computed: {
    ...mapGetters("account", ["account"])
  },
  methods: {
    ...mapActions("account", ["get", "clean", "getOrders"]),
    initialize() {
      if (this.$route.params.id) {
        this.accountId = parseInt(this.$route.params.id);
        this.get(this.accountId);
        this.getOrders(this.accountId).then(data => {
          this.orders = data;
        });
      } else {
        this.$router.push("/account");
      }
    },
    getColor(status) {
      if (status == "paid") {
        return "red";
      }
      return "green";
    },
    viewOrder(order) {
      this.$router.push("/orders/view/" + order.id);
    }
  },
  beforeDestroy() {
    this.clean();
  }
};
</script>

<style>
</style>